








import { Vue, Component } from 'vue-property-decorator'

const config = {
  name: 'icon-drop-up',
  components: {}
}

@Component(config)
export default class IconDropUp extends Vue {}
